import React from 'react';
import './button.css';
import Translate from "../localization/Translate";
import Button from "./Button";
import {useDispatch, useSelector} from "react-redux";
import {
    closeRightPanelDialogue,
    showRightPanelDialogue
} from "../redux/actions";
import EnterPromoCode from "../campaigns/onePromotion/EnterPromoCode";

export default function ({promotionSet, onRemovePromotion, promotionSetClass, promotionSetButtonName, onPromotionInputDone}) {
    const dispatch = useDispatch();
    const transactionHasPayment = useSelector(state => state.payment.payments.length > 0);
    const isReturnTransaction = useSelector(state =>
        state.rootReducer.productsInBasket.filter(product => product.amount < 0).length === state.rootReducer.productsInBasket.length);


    if(promotionSet){
        return (
            <Button
                removeSign={!transactionHasPayment}
                onClick={() => {
                    if(!transactionHasPayment){
                        onRemovePromotion();
                    }
                }}
                type="button"
                className={"largeRoundButton " + promotionSetClass}
                name={promotionSetButtonName}
                style={{
                    minWidth: '17.14rem',
                    marginTop: '1rem'
                }}
            />
        );
    }

    if(transactionHasPayment || isReturnTransaction){
        return <></>;
    }

    return (
        <Button
            plusSign
            onClick={() => {
                dispatch(showRightPanelDialogue(
                    <EnterPromoCode
                        onInputDone={(value) => {
                            onPromotionInputDone(value);
                            dispatch(closeRightPanelDialogue());
                        }}
                        onBack={() => {
                            dispatch(closeRightPanelDialogue());
                        }}
                    />, "enterPromoCode"));
            }}
            type="button"
            className={"largeRoundButton blueButton"}
            name={<Translate id="add a promo code"/>}
            style={{
                minWidth: '17.14rem'
            }}
        />
    );
}
